export class PaginationHelper {
	static readonly minPageSize = 1;
	static readonly maxPageSize = 200;

	public static normalizePageNumber(pageNumber: number): number {
		if (!Number.isFinite(pageNumber) || pageNumber < 0) {
			return 0;
		}

		return Math.floor(pageNumber);
	}

	public static normalizePageSize(pageSize: number): number {
		if (!Number.isFinite(pageSize) || pageSize < this.minPageSize) {
			return this.minPageSize;
		}

		return Math.min(Math.floor(pageSize), this.maxPageSize);
	}

	public static normalizePageCount(pageCount: number): number {
		if (!Number.isFinite(pageCount) || pageCount < 1) {
			return 1;
		}

		return Math.floor(pageCount);
	}
}
